import React, { useEffect, useState } from "react";

const PhotoSlider = ({ apiUrl, aspectRatio = "4/3", autoPlay = true, interval = 4000 }) => {
  const [photos, setPhotos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch images from WP REST API
  useEffect(() => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        if (data.length) {
          const content = data[0].content.rendered;
          const imageUrls = Array.from(
            content.matchAll(/<img[^>]+src="([^">]+)"/g)
          ).map((match) => match[1]);
          setPhotos(imageUrls);
        }
      })
      .catch((err) => console.error("Error fetching photos:", err));
  }, [apiUrl]);

  // Auto-play slideshow
  useEffect(() => {
    if (autoPlay && photos.length > 0) {
      const timer = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % photos.length);
      }, interval);
      return () => clearInterval(timer);
    }
  }, [autoPlay, photos, interval]);

  return (
    <div className={`relative w-full max-w-3xl aspect-[${aspectRatio}] overflow-hidden rounded-lg shadow-lg`}>
      {photos.length > 0 ? (
        <>
          {/* Image */}
          <img
            src={photos[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
            className="w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-105"
          />

          {/* Navigation Dots */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {photos.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-1 h-1 rounded-full transition-colors duration-300 ${
                  currentIndex === index ? "bg-yellow-500" : "bg-gray-300 hover:bg-gray-400"
                }`}
              />
            ))}
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center w-full h-full bg-gray-200">
          <p className="text-gray-500">Loading photos...</p>
        </div>
      )}
    </div>
  );
};

export default PhotoSlider;
